import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decodeDataforkey } from "./config/encodelocalstorage";
import { httpConfig } from "./httpConfig";
import { RequestFetch } from "./config/requestFetch";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";
import Swal from "sweetalert2";
import { decodeToken } from "react-jwt";

const Pageconfirmshare = () => {
  const { docobj } = useParams();
  const navigat = useNavigate();
  const dataobjis = decodeDataforkey(atob(docobj));
  const [detaildatashare, setDetaildatashare] = useState(null);
  const [checkshowbtnclick, setCheckshowbtnclick] = useState(true);
  const [pinforcheck, setPinforcheck] = useState([]);
  const [pinis, setPinis] = useState(null);
  const [atoken, setAtoken] = useState(null);
  const [confrimissuccess, setConfrimissuccess] = useState(false);
  const [statusconfirm, setStatusconfirm] = useState(null);
  const [statusCancle, setStatusCancle] = useState(null);
  //รายการใหม่ เมื่อมีการคลิกยอมรับและปฎิเสธ
  const [confrimPinsuccess, setConfrimPinsuccess] = useState(null);
  const [sendmessageShareTotal, setSendmessageShareTotal] = useState(null);

  const docgetID = (id) => {
    return document.getElementById(id);
  };

  //อันนี้ดึงข้อมูลมาโชว์
  const handlegetdetaildata = async (obj) => {
    let objsend = {
      advisor_id: obj.shareiddoc,
      work_id: obj.workid,
    };
    await fetch(
      `${httpConfig()}/messageConfrimPage`,
      RequestFetch("POST", objsend)
    ).then((res) =>
      res.json().then((data) => {
        console.log("ข้อมูลที่จะนำมาแสดงคือ", data);
        setDetaildatashare(data);
        if (data) {
          let checkdatacancle;
          data.map((ele) => {
            if (ele.cancle === 0) {
              checkdatacancle = true;
            } else if (ele.cancle > 0) {
              checkdatacancle = false;
            }
          });
          console.log("checkshowbtnclick จะเป็น", checkdatacancle);
          setCheckshowbtnclick(checkdatacancle);
        }
      })
    );
  };

  const handlesetpinshow = () => {
    let result = "";
    let countlg = pinforcheck.length;
    if (countlg <= 6) {
      pinforcheck.map((ele) => {
        result = `${result}${ele}`;
      });
      // console.log("result ->", result);
      setPinis(result);
    }
  };

  const handleslicepin = () => {
    let countlg = pinforcheck.length;
    if (countlg <= 1) {
      setPinis(null);
    } else {
      let cut = countlg - 1;
      let result = "";
      let arr_map = pinforcheck.slice(0, cut);
      arr_map.map((ele) => {
        result = `${result}${ele}`;
      });
      setPinforcheck(arr_map);
      setPinis(result);
    }
  };

  const handleClearreset = () => {
    setPinforcheck([]);
    setPinis(null);
  };

  const handleshowNoteAndConfirmPIN = () => {
    setTimeout(() => {
      docgetID("modelConfirmpin").style.display = "flex";
    }, 180);
  };

  const handlesetPINforcheck = (value) => {
    let countlg = pinforcheck.length;
    if (countlg < 6) {
      setPinforcheck((item) => [...item, value]);
    }
  };

  const handlechktokenforlogin = (pinis) => {
    // console.log("แล้วยังไงงง", pinis);
    fetch(`${httpConfig()}/login`, RequestFetch("POST", { pin: pinis })).then(
      (res) => {
        res.json().then((data) => {
          if (data) {
            console.log("login data ...>", data);
            if (data.token) {
              setAtoken(data.token);
            }
          }
        });
      }
    );
  };

  //ส่งแจ้งเตือนกลับไปยังผู้ที่ยื่นแลกเปลี่ยนงานมา
  const handleNoficationMessage = async (docid, usertoken, statusShare) => {
    await fetch(
      `${httpConfig()}/LineNotifyGrp`,
      RequestFetch("POST", { iddoc: docid }, usertoken)
    ).then((res) => {
      if (res.status === 200) {
        res.json().then((data) => {
          if (data) {
            console.log("รายการของ advisor Id", docid, "datais", data);
            console.log("ถอดรายการ token", decodeToken(atoken));
            let resultTokendecode = decodeToken(atoken);
            let tokengrpLine = data[0].line_grp;
            // let message_sendline = `แลกงานประเมิน \nหัวข้อ ${detaildatashare[0].sheetname}   \nอาจารย์ ${resultTokendecode.username} \nที่ยื่นไปได้รับประเมินงานให้เป็นที่เรียบร้อยแล้ว`;
            let message_sendobject = {
              topic: detaildatashare[0].sheetname,
              date: moment(detaildatashare[0].date)
                .add(543, "year")
                .format("DD/MM/YYYY"),
              advisoris: `${resultTokendecode.username}`,
            };
            let objectLineRequest = {
              userIdline: tokengrpLine,
              messageline: message_sendobject,
              tokenline:
                "a1WgRpp1JcYxXzRvvIgFb1GRBwfsx1aWRO2jBjnAF+8ZkR5+bChmQ1+1sy4algb7EHqklOJyaReHBbHGyzC92sZ4WQJNz/Bg2Nzyu9QpFFu1JQ+QoNQMoBISvZykmw5XJ/bKoxnG/u43XzHIpKnUiQdB04t89/1O/w1cDnyilFU=",
            };
            // // console.log('objectLineRequset',objectLineRequest)
            if (statusShare === true) {
              fetch(
                `${httpConfig()}/sendmessageLINEoa_shareSuccess`,
                RequestFetch("POST", objectLineRequest)
              ).then((res) => {
                if (res.ok) {
                  console.log("message LINE is send !!!");
                }
              });
            } else if (statusShare === false) {
              fetch(
                `${httpConfig()}/sendmessageLINEoa_shareUnsuccess`,
                RequestFetch("POST", objectLineRequest)
              ).then((res) => {
                if (res.ok) {
                  console.log("message LINE is send !!!");
                }
              });
            }

            //แจ้งเตือนในรูปแบบของ line notify
            // console.log("ตอนนี้อยากดูลิงค์ที่ส่ง", message_sendline);
            // console.log("tokenline หายกา!!!", tokengrpLine);
            // let bodyrequest_lineNotify = {
            //   grptoken: tokengrpLine,
            //   // grptoken: "H7XB8a4YTbHjuLob0a7y5WYdh8o9ck2e1XrnFGNC66U",
            //   messagesend: message_sendline,
            // };

            // fetch(
            //   `${httpConfig()}/proxyLineNotify`,
            //   RequestFetch("POST", bodyrequest_lineNotify, usertoken)
            // ).then((res) => {
            //   if (res.status === 200) {
            //     res.json().then((data) => {
            //       console.log(data.message);
            //     });
            //   }
            // });
          }
        });
      }
    });
  };

  //ตอนกดตอบรับและเช็ค PIN เรียบร้อยแล้ว
  const handleforConfrimshareingnow = (
    workid,
    own_docid,
    share_docid,
    usetoken
  ) => {
    let bodyfetch_workconfirm = {
      workid: workid,
      docown: share_docid, //share ที่นี้คือ คนที่ได้รับลิงค์
      docshare: share_docid, //where advisro_share
    };
    let bodyfetch_messageconfirm = {
      workID: workid,
      advisorID: share_docid,
    };
    fetch(
      `${httpConfig()}/messageconfirm`,
      RequestFetch("PUT", bodyfetch_messageconfirm, usetoken)
    )
      .then((res) => {
        if (res.status === 200) {
          res.json().then(() => {
            setAtoken(null);
          });
        } else {
          console.error("fail to fetch messageconfirm !!!");
          setAtoken(null);
        }
      })
      .catch((err) => {
        console.error("fail to fetch messageconfirm ::", err);
        setAtoken(null);
      });
    fetch(
      `${httpConfig()}/workconfirmshare`,
      RequestFetch("PUT", bodyfetch_workconfirm, usetoken)
    )
      .then((res) => {
        if (res.status === 200) {
          res.json().then(() => {
            setAtoken(null);
            setConfrimissuccess(true); //เมื่อมีการตอบรับ
            docgetID("modelConfirmpin").style.display = "none";
            // handleNoficationMessage(own_docid, atoken);
          });
        } else {
          console.error("fail to fetch workconfirmshare !!!");
          setAtoken(null);
        }
      })
      .catch((err) => {
        console.error("fail to fetch workconfirmshare ::", err);
        setAtoken(null);
      });
  };

  // เมื่อมีการกด ปฎิเสธรับ การประเมิน
  const handleforCancelshareingnow = (workid, ownShareid, usertoken) => {
    // ยิงfetchไป สองตัวเน้อ
    // workunshare ใช้ตัว bodyFetchunshare กับ messagecancle ใช้ bodyCancel
    let bodyFetchunshare = {
      workid: workid,
    };
    let bodycancel = {
      idwork: workid,
      idadvisor: ownShareid,
    };
    console.log("เข้ามาทำงานการยกเลิกรับงานนี้", bodyFetchunshare);
    console.log("และ", bodycancel);
    docgetID("modelConfirmpin").style.display = "none";

    // ทำการยิง api
    fetch(
      `${httpConfig()}/messagecancle`,
      RequestFetch("PUT", bodycancel, usertoken)
    ).then((res) =>
      res.json((message) => {
        if (message) {
          console.log("messagecancle!!!", message);
        }
      })
    );
    fetch(
      `${httpConfig()}/workunshare`,
      RequestFetch("PUT", bodyFetchunshare, usertoken)
    ).then((res) =>
      res.json().then((message) => {
        if (message) {
          console.log("workunshare!!!", message);
          setStatusCancle(true); //เมื่อมีการปฎิเสธ
        }
      })
    );
  };

  //แสดงรายการรายละเอียด และ รายละเอียดเมื่อตอบรับสำเร็จ
  const handledetailorconfirmShow = (issuccess) => {
    // ปรับเปลี่ยนรูปแบบใหม่
    if (confrimPinsuccess) {
      return (
        <div className="boxbody-cardshowdetail-pageconfirmshare">
          <div className="iconshow">
            <div className="circlebox">
              <Icon className="iconletter" icon="el:question" />
            </div>
            <div className="detail">
              <span>{"ท่านต้องการรับการประเมิน หรือ ไม่ ???"}</span>
            </div>
            <div
              className="btn-showconfrim"
              style={
                checkshowbtnclick ? { display: "block" } : { display: "none" }
              }
            >
              <button
                className="btncancel-showconfirm"
                onClick={() => {
                  Swal.fire({
                    icon: "warning",
                    title: "ยืนยันรายการ",
                    text: "ต้องการปฎิเสธตอบรับการประเมิน ใช่ หรือ ไม่ ???",
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: "ยืนยัน",
                    cancelButtonText: "ยกเลิก",
                    confirmButtonColor: "#4ea264",
                    color: "#cb3c28",
                  }).then((res) => {
                    if (res.isConfirmed) {
                      // console.log("เมื่อ ปฎิเสธ", dataobjis, atoken);
                      handleforCancelshareingnow(
                        dataobjis.workid,
                        dataobjis.shareiddoc,
                        atoken
                      );

                      //ทดสอบ
                      setStatusCancle(true);
                      setConfrimPinsuccess(false);
                      setSendmessageShareTotal({
                        status: true,
                        caseis: "Unconfirmshare",
                      });
                    }
                  });
                }}
              >
                {"ปฎิเสธ"}
              </button>
              <button
                className="btnconfirm-showconfirm"
                onClick={() => {
                  Swal.fire({
                    icon: "warning",
                    title: "ยืนยันรายการ",
                    text: "ต้องการตอบรับการประเมิน ใช่ หรือ ไม่ ???",
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: "ยืนยัน",
                    cancelButtonText: "ยกเลิก",
                    confirmButtonColor: "#4ea264",
                    color: "#4ea264",
                  }).then((res) => {
                    if (res.isConfirmed) {
                      // console.log("เมื่อ ยอมรับ", dataobjis, atoken);
                      handleforConfrimshareingnow(
                        dataobjis.workid,
                        dataobjis.ownId,
                        dataobjis.shareiddoc,
                        atoken
                      );

                      // ทดสอบ
                      setConfrimissuccess(true);
                      setConfrimPinsuccess(false);
                      setSendmessageShareTotal({
                        status: true,
                        caseis: "confirmshare",
                      });
                    }
                  });
                }}
              >
                {"ยอมรับ"}
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      // console.log("status Confirm", confrimissuccess);
      // console.log("status Cancel", statusCancle);
      if (confrimissuccess === true) {
        return (
          <div
            className="boxbody-cardshowdetail-pageconfirmshare"
            style={{ background: "none" }}
          >
            <div className="iconshow">
              <div className="circlebox">
                <Icon className="iconletter" icon="mdi:success-bold" />
              </div>
              <div className="box-showingsuccessmessage">
                <div>
                  <span>{`ท่านได้รับงานประเมินใหม่ หัวข้อ ${detaildatashare[0].sheetname}`}</span>
                </div>
                <div>
                  <span>{`ท่านรับประเมินงานวันที่ ${moment(
                    detaildatashare[0].date
                  )
                    .add(543, "year")
                    .format("DD/MM/YYYY")}`}</span>
                </div>
                <div>
                  <span>{"ท่านสามารถเข้าไปยังเว็บแอพพลิเคชัน"}</span>
                </div>
                <div>
                  <span>{"เพื่อดำเนินการประเมินต่อไป"}</span>
                </div>
                <div className="btn-showbutton">
                  <button
                    type="button"
                    onClick={() => {
                      navigat("https://datasoft.co.th/estimate");
                    }}
                  >
                    {"คลิกเพื่อไปหน้างานหลัก"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      } else if (statusCancle === true) {
        return (
          <div
            className="boxbody-cardshowdetail-pageconfirmshare"
            style={{ background: "none" }}
          >
            <div className="iconshow">
              <div
                className="circlebox"
                style={{
                  backgroundColor: "#cb3c28",
                  border: "2px solid #cb3c28",
                }}
              >
                <Icon className="iconletter" icon="mdi:success-bold" />
              </div>
              <div className="box-showingsuccessmessage">
                <div style={{ color: "#cb3c28" }}>
                  <span>{`ท่านได้ปฎิเสธ การฝากงานเรียบร้อยแล้ว !!!`}</span>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
    //รูปแบบเดิม
    // if (issuccess) {
    //   return (
    //     <div
    //       className="boxbody-cardshowdetail-pageconfirmshare"
    //       style={{ background: "none" }}
    //     >
    //       <div className="iconshow">
    //         <div className="circlebox">
    //           <Icon className="iconletter" icon="mdi:success-bold" />
    //         </div>
    //         <div className="box-showingsuccessmessage">
    //           <div>
    //             <span>{`ท่านได้รับงานประเมินใหม่ หัวข้อ ${detaildatashare[0].sheetname}`}</span>
    //           </div>
    //           <div>
    //             <span>{`ท่านรับประเมินงานวันที่ ${moment(
    //               detaildatashare[0].date
    //             )
    //               .add(543, "year")
    //               .format("DD/MM/YYYY")}`}</span>
    //           </div>
    //           <div>
    //             <span>{"ท่านสามารถเข้าไปยังเว็บแอพพลิเคชัน"}</span>
    //           </div>
    //           <div>
    //             <span>{"เพื่อดำเนินการประเมินต่อไป"}</span>
    //           </div>
    //           <div className="btn-showbutton">
    //             <button
    //               type="button"
    //               onClick={() => {
    //                 navigat("/");
    //               }}
    //             >
    //               {"คลิกเพื่อไปหน้างานหลัก"}
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // } else {
    //   return (
    //     <div className="boxbody-cardshowdetail-pageconfirmshare">
    //       <div className="iconshow">
    //         <div
    //           className="circlebox"
    //           style={
    //             statusCancle
    //               ? { border: "2px solid #bb2010", backgroundColor: "#bb2010" }
    //               : {}
    //           }
    //         >
    //           {statusCancle ? (
    //             <Icon className="iconletter" icon="clarity:email-solid" />
    //           ) : (
    //             <Icon className="iconletter" icon="clarity:email-solid" />
    //           )}
    //         </div>
    //       </div>
    //       <div
    //         className="headtitle"
    //         style={statusCancle ? { color: "#bb2010" } : {}}
    //       >
    //         <b>{"ฝากงานประเมิน"}</b>
    //       </div>
    //       {/* <div className="detail">
    //         <span>{"ท่านได้รับฝากงานประเมิน"}</span>
    //       </div> */}
    //       {detaildatashare
    //         ? detaildatashare.map((ele, key) => {
    //             if (ele.cancle !== 1) {
    //               return (
    //                 <div
    //                   className="detail"
    //                   key={key}
    //                   style={statusCancle ? { color: "#bb2010" } : {}}
    //                 >
    //                   <div>
    //                     <span>{`หัวข้อ : ${ele.sheetname}`}</span>
    //                   </div>
    //                   <div>
    //                     <span>{`วันที่ : ${moment(ele.date)
    //                       .add(543, "year")
    //                       .format("DD/MM/YYYY")} `}</span>
    //                   </div>
    //                   <div>
    //                     <span>{`จาก : อาจารย์ ${ele.share_ttl} ${ele.share_name} ${ele.share_lname}`}</span>
    //                   </div>
    //                   <div>
    //                     <span style={{ fontSize: "80%" }}>
    //                       {
    //                         "คลิกยอมรับ และ ยืนยันรหัส PIN ของท่าน เพื่อตอบรับงานประเมิน"
    //                       }
    //                     </span>
    //                   </div>
    //                 </div>
    //               );
    //             }
    //           })
    //         : ""}
    //       {statusCancle ? (
    //         <div className="textshowcancle-whencancel">
    //           <span>{"ปฎิเสธการฝากงาน"}</span>
    //         </div>
    //       ) : (
    //         <div
    //           className="btn-showconfrim"
    //           style={
    //             checkshowbtnclick ? { display: "block" } : { display: "none" }
    //           }
    //         >
    //           {/* <button
    //             className="btncancel-showconfirm"
    //             onClick={() => {
    //               handleshowNoteAndConfirmPIN();
    //               setStatusconfirm(false);
    //             }}
    //           >
    //             {"ปฎิเสธ"}
    //           </button> */}
    //           <button
    //             className="btnconfirm-showconfirm"
    //             onClick={() => {
    //               handleshowNoteAndConfirmPIN();
    //               setStatusconfirm(true);
    //             }}
    //           >
    //             {"ยอมรับ"}
    //           </button>
    //         </div>
    //       )}
    //     </div>
    //   );
    // }
  };

  useEffect(() => {
    console.log("objparams is >>", dataobjis);
    handlegetdetaildata(dataobjis);
    //แสดงรายการใหม่
    docgetID("modelConfirmpin").style.display = "flex"; // เรียกเปิด model กรอกพิน
    docgetID("closerbuttonConfirmpim").style.display = "none";
    setStatusconfirm(true);
  }, []);

  useEffect(() => {
    if (!pinforcheck[0]) return;
    handlesetpinshow();
  }, [pinforcheck]);

  useEffect(() => {
    if (!checkshowbtnclick) {
      if (confrimissuccess) return;
      navigat("/page202Confirmshare");
    }
  }, [checkshowbtnclick]);

  useEffect(() => {
    if (!pinis || pinis.length < 6) return;
    if (pinis) {
      let objecttocheck = {
        id_advisor: dataobjis.shareiddoc,
        pin_advisor: pinis,
      };
      fetch(
        `${httpConfig()}/messageCheckPINadvisor`,
        RequestFetch("POST", objecttocheck)
      ).then((res) =>
        res.json().then((data) => {
          if (data) {
            if (data.status || data.status === true) {
              handlechktokenforlogin(pinis);
            } else {
              Swal.fire({
                title: "รหัสผ่านผิดพลาด!!!",
                icon: "warning",
                showConfirmButton: false,
                showCancelButton: false,
                timer: 1700,
              }).then(() => {
                //แบบเดิม
                // docgetID("modelConfirmpin").style.display = "none";
                // setPinis(null);
                // setPinforcheck([]);
                //แบบใหม่ กรอก PIN ก่อนเพื่อให้ยืนยันรับ หรือ ไม่รับอีกที
                setPinis(null);
                setPinforcheck([]);
              });
            }
          }
        })
      );
    }
  }, [pinis]);

  useEffect(() => {
    if (!atoken) return;
    if (atoken) {
      console.log("มีโทเค้นแล้วจ้า!!!!", atoken);
      docgetID("modelConfirmpin").style.display = "none"; // เรียกปิด model กรอกพิน
      setConfrimPinsuccess(true);
      // if (statusconfirm !== null) {
      //   if (statusconfirm) {
      //     handleforConfrimshareingnow(
      //       dataobjis.workid,
      //       dataobjis.ownId,
      //       dataobjis.shareiddoc,
      //       atoken
      //     );
      //   } else {
      //     handleforCancelshareingnow(
      //       dataobjis.workid,
      //       dataobjis.shareiddoc,
      //       atoken
      //     );
      //   }
      // }
    }
  }, [atoken]);

  useEffect(() => {
    if (statusCancle) {
    }
  }, [statusCancle]);

  useEffect(() => {
    if (!sendmessageShareTotal || sendmessageShareTotal === null) return;
    if (sendmessageShareTotal) {
      if (sendmessageShareTotal.status === true) {
        if (sendmessageShareTotal.caseis === "confirmshare") {
          handleNoficationMessage(dataobjis.ownId, atoken, true);
          setSendmessageShareTotal(null);
        } else if (sendmessageShareTotal.caseis === "Unconfirmshare") {
          handleNoficationMessage(dataobjis.ownId, atoken, false);
          setSendmessageShareTotal(null);
        }
      }
    }
  }, [sendmessageShareTotal]);

  return (
    <div className="bodycontgent-confirmshare">
      <div className="content-page-confirmshare">
        <div className="title-note-pageconfirmshare">
          <span>{"คำขอฝากงาน"}</span>
        </div>
        {handledetailorconfirmShow(confrimissuccess)}
        <div className="footer-content">
          <div
            className="noteshowdetail-footer"
            // style={confrimissuccess ? { display: "none" } :  {}}
            style={
              confrimissuccess
                ? { display: "none" }
                : statusCancle
                ? { display: "none" }
                : {}
            }
          >
            <span>{`หมายเหตุ : หากต้องการฝากงานกลับไปยังอาจารย์คนดังกล่าว
              สามารถฝากงานได้บน เว็บแอพพลิเคชั่นการประเมิน Estimate`}</span>
          </div>
          <div className="credit-footer">
            <span>{"แบบตอบรับการยื่นฝากประเมิน จัดทำโดย "}</span>
            <a
              href="https://datasoft.co.th/estimate"
              style={{ textDecoration: "underline" }}
            >
              {"©datasoft.co.th/estimate"}
            </a>
          </div>
        </div>
        <div className="model-confrimpin" id="modelConfirmpin">
          <div className="closerBoxmodel" id="closerbuttonConfirmpim">
            <Icon
              onClick={() => {
                docgetID("modelConfirmpin").style.display = "none";
                setPinis(null);
                setPinforcheck([]);
              }}
              icon="mdi:window-close"
            />
          </div>
          <div className="formconfrimpin">
            <h2 style={!statusconfirm ? { color: "#b0120a" } : {}}>
              {statusconfirm
                ? "ยืนยันตอบรับการประเมิน"
                : "ยืนยันการปฎิเสธการประเมิน"}
            </h2>
            <div className="showpassword">
              <input
                type="password"
                placeholder="- - - - - -"
                defaultValue={pinis}
                readOnly
              ></input>
            </div>
            <div className="gridBoxnumber">
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("1");
                }}
                style={
                  !statusconfirm
                    ? {
                        border: "2px solid #b0120a",
                        color: "#d01716",
                      }
                    : {}
                }
              >
                {"1"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("2");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"2"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("3");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"3"}
              </button>
            </div>
            <div className="gridBoxnumber">
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("4");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"4"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("5");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"5"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("6");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"6"}
              </button>
            </div>
            <div className="gridBoxnumber">
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("7");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"7"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("8");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"8"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("9");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"9"}
              </button>
            </div>
            <div className="gridBoxnumber">
              <button
                type="button"
                onClick={() => {
                  handleClearreset();
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                <Icon icon="system-uicons:reset-alt" />
              </button>
              <button
                type="button"
                onClick={() => {
                  handlesetPINforcheck("0");
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                {"0"}
              </button>
              <button
                type="button"
                onClick={() => {
                  handleslicepin();
                }}
                style={
                  !statusconfirm
                    ? { border: "2px solid #b0120a", color: "#d01716" }
                    : {}
                }
              >
                <Icon icon="ep:back" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Pageconfirmshare;
